export default __webpack_public_path__ + "static/media/element_spec_79.1185d553.webp";